"use client"

import { BlockchainIcon } from "@/app/blockchains/blockchain-icon/blockchain-icon"
import { Copy } from "@/app/components/copy/copy"
import { useFormattedAddress } from "@/app/wallet-connect/hooks"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { CollectionMoleculeReatom } from "../../store/index.reatom"

export const CollectionContract = reatomComponent(() => {
  const { blockchain, collectionAddress } = useMolecule(
    CollectionMoleculeReatom,
  )
  const formattedAddress = useFormattedAddress(collectionAddress)

  return (
    <div className="flex items-center gap-1">
      <div className="relative h-3 w-3">
        <BlockchainIcon blockchain={blockchain} />
      </div>
      <Copy
        className="text-foreground/60"
        withIcon
        copyValue={collectionAddress}
      >
        {formattedAddress}
      </Copy>
    </div>
  )
}, "CollectionContract")
